export enum AssetContentType {
  AssetInformation = 1,
  ThreeDModel,
  Documents,
  MatterPortModel,
  NetworkMap,
}
